import React from 'react';
import { Text } from '~/components';

export interface LeftTextProps {
  children: string;
}

const LeftText: React.FC<LeftTextProps> = ({ children }) => {
  return <Text className="text-gray-400 text-sm">{children}</Text>;
};

export default LeftText;
